/*!
 * FW Form Modul
 * Enhances the CF7 form
 *
 * Fugee-Child 
 * Austrian Wordpress Child-Theme for Refugees Welcome Network Sites 
 * @author Christoph Listabarth <christoph.listabarth@gmail.com> 
 * @version 1.0.0 (18356be)
 * Copyright 2017 Flüchtlinge Willkommen / Refugees Welcome
 *
 *
 * - shows form pages in a carousel
 * - adds translation to forms
 * - adds custom city dropdowns
 * - sets custom datepicker options
 * - adds frontend validation
 */

(function ( $ ) {
 
    $.fn.fwform = function() {
        
    	return this.each(function(){

			// ------------------------------
			// INIT
			// ------------------------------
			var form = $(this); // needed for pagination, language support
			
			var isWG = false;
			var isRefugee = false;
			
			var defaultLanguage = ''; //will be set in the json files
		    
		    var cityList = 'fw-cities-de.json'; // WG 
		    var cityListComplete = 'fw-cities-de-complete.json';  // Refugee

		    var wgLangFile = 'fw-lang.json';
		    var refugeeLangFile = 'fw-lang.json';
		    
		    var jsDir = fugee.templateDir + '/dist/json_data/';

		    var cityListFile, languageFile;

			// set up form specific parameters
			// @todo: outsource the city and language file dependencies to a data-attribute or other parameter
			switch(form.attr('id')){
				case 'wg-signup':
					isWG = true;
		    		cityListFile = jsDir + cityList;
		    		languageFile = jsDir + wgLangFile;
					break;

				case 'refugee-signup':
					isRefugee = true;
		    		cityListFile = jsDir + cityListComplete;
		    		languageFile = jsDir + refugeeLangFile;
					break;
			}		
			// end init


			// Close / Cancel Form
			// ----------------------------------
			$('button[data-dismiss="lightbox"]', form).on('click', function(){
                resetForm();            
                window.parent.postMessage(JSON.stringify({ action : 'closeForm' }), "*");
            });
			

			// Carousel
			// Custom Next / Prev Navigation
			// -------------------------------
			$('.carousel-control-wrapper button', form).on('click', function(event){
				var direction = $(this).data('slide');
				if(direction === 'next'){
					// validate
					if(validateCurrentPage()){
						$('.fw-carousel').carousel('next');				
					} else {
						console.log('validation error');
					}			
				} else if(direction === 'prev') {
					$('.fw-carousel').carousel('prev');
				}

				event.preventDefault();
			});

			// Submit
			// ----------------------------
			$('.wpcf7-submit', form).on('click', function(){
				if(!validateCurrentPage()){
					return false;
				}
			});

			// Event: on carousel change
			// ----------------------------
			$('.fw-carousel', form).on('slide.bs.carousel', function (event) {
				var eventObj = $(event)[0];
				var step = $(eventObj.relatedTarget).index();

				// show progress
				var stepElements = $('.steps li', form);
				stepElements.each(function(index, stepEl){
					if($(stepEl).index() <= step){
						$(stepEl).addClass('active');
					} else {
						$(stepEl).removeClass('active');
					}
				});

				//jump to top
				form.scrollTop(0);

				// Show/Hide Weiter Button
				if(step === stepElements.length - 1){
					$('#btn-carousel-next', form).addClass('inactive');
				} else {
					$('#btn-carousel-next', form).removeClass('inactive');
				}

				// Show/Hide Zurück Button
				if(step >= 1){
					$('#btn-carousel-prev', form).removeClass('inactive');
				} else {
					$('#btn-carousel-prev', form).addClass('inactive');
				}
			});

			// Init tooltips
			// -----------------------------
			form.find('[data-toggle="tooltip"]').tooltip();


			// Form / Reset
			// -----------------------------
			function resetForm(){
				// clear form
				form.parents('form').trigger('reset');

				// reset specific form elements
				$('.date-move-out', form).removeClass('inactive');
				$('.costs-wrapper, #costs', form).removeClass('inactive');
				$('.morelanguages', form).removeClass('active').find('input').removeClass('wpcf7-validates-as-required wpcf7-not-valid');
				$('.morelanguages input', form).val('');		

				// reset chosen select to '--' option
				$('.fw-chosen-city', form)
					.find('option:first-child').prop('selected', true)
					.end().trigger("chosen:updated");


				// reset all error alerts
				$('.wpcf7-not-valid', form).removeClass('wpcf7-not-valid');
				$('.wpcf7-not-valid-tip, .wpcf7-response-output-pagewise', form).remove();
				$('.wpcf7-response-output.wpcf7-mail-sent-ok', form).removeClass('wpcf7-mail-sent-ok').html('').hide();

		        // jump to start of form carousel
		        $('.fw-carousel', form).carousel(0);
		        
		        // reset classes
		        form.parents('form').removeClass('sent');
		        form.removeClass('single-lang');
			}

			// Fill Autocomplete
			// -----------------------------
			// https://harvesthq.github.io/chosen/

		    var states = {};
		    var allCities = [];

		    function loadCitiesList(file) {
				$.ajax({
			        url: file,
			        dataType: 'json',
			        success: function(data) {
			        	states = data;
			        	allCities = [];
			        	$.each(states, function(i, val){
			        		allCities = allCities.concat(val);
			        	});
						
						allCities = allCities.sort();
						updateStateSelect(allCities);

						$('.fw-chosen-city', form).chosen({
							no_results_text: "Deine Stadt ist leider nicht dabei!",
							placeholder_text_single: "Wähle deine Stadt aus",
			    			width: "100%"
						});
			        },
			        error: function(data){
			        	console.log('Error: file not found at url' + file);
			        }
			    });
		    }
		    loadCitiesList(cityListFile);


			// use this for smaller city lists
			// the state will automatically be chosen via the selected city
			$('.fw-chosen-city', form).on('change', function(){
				var cityName = $(this).val();	
				var stateName = '';
				// var modal = $(this).parents('.fw-form');

				$.each(states, function(state, cities){
		    		$.each(cities, function(i, city){
		    			if(cityName === city) {
		    				stateName = state;
		    			}
		    		});
		    	});

				$('.fw-chosen-state', form).val(stateName);
			});


			// Change the available cities according to the chosen bundesland
			// $('.fw-chosen-state').on('change', function(){
			// 	var stateName = $(this).val();

			// 	if(stateName !== ''){
			// 		var citiesForState = states[stateName];
					
			// 		updateStateSelect(citiesForState);
			// 		$('.fw-chosen-city').trigger("chosen:updated");
					
			// 		console.log('stateName: ', stateName);
			// 		console.log('citiesForState: ', citiesForState);
			// 	} else {
			// 		updateStateSelect(allCities);
			// 		$('.fw-chosen-city').trigger("chosen:updated");			
			// 	}
			// });

			function updateStateSelect(cityArray){
				var options = '';
				var first = '<option value="">--</option>';

				$.each(cityArray, function(i, city){
					options += '<option value="'+city+'">'+city+'</option>';
				});
				
				$('.fw-chosen-city option', form).remove();
				$('.fw-chosen-city', form).append(first + options);
				// console.log('chosen:', cityArray);
			}

			// Date Picker
			// ---------------------------------
			// http://api.jqueryui.com/datepicker/

			// Add altField to all Datepicker so we can send a date in one format and display it in another (language format)
			$('input.datepicker', form).each(function(i, dp){
				var name = $(dp).attr('name');
				var altClass = name + '-send';
				var alt = '<input class="' + altClass + '" type="hidden" name="' + name + '">';

				$(dp).before(alt);
				$(dp).removeAttr('name');			
				$(dp).datepicker({
					altField: '.' + altClass,
					altFormat: "dd.mm.yy"
				});
			});

			// Override options for specific dp
			$("#date-start", form).datepicker("option", "minDate", '+1m');
			$("#date-end", form).datepicker("option", "minDate", '0');


			$("#date-start", form).on('change', function(){
				var dateArray = $(this).val().split('.');
				var dateInMonth = new Date(dateArray[2], dateArray[1]-1+6, dateArray[0]);
				
				// insert calculated min date for date-end datepicker
				$("#date-end", form).datepicker( "option", "minDate", dateInMonth);
				
				// set Dauer field
				calcLength();
			});

			// set Dauer field
			$("#date-end", form).on('change', function(){
				calcLength();
			});

			// check open-end
			$(".open-end input[type='checkbox']", form).on('change', function(){
				if($(this).is(':checked')){
					$("#date-end", form).datepicker( "setDate", null );
					$(".date-move-out", form).addClass('inactive');
					$('input[name="dauer"]', form).val('unbefristet');
				} else {
					$(".date-move-out", form).removeClass('inactive');
					$('input[name="dauer"]', form).val('');
				}
			});

			// Other Languages
			// ---------------------------------
			$('input[type="checkbox"][name*="lang"][value*="Other"], input[type="checkbox"][name*="lang"][value*="Andere"]', form).on('change', function(){
				if($(this).is(':checked')){
					$('.morelanguages', form).addClass('active').find('input').addClass('wpcf7-validates-as-required');
				} else {
					$('.morelanguages', form).removeClass('active').find('input').removeClass('wpcf7-validates-as-required wpcf7-not-valid');
					$('.morelanguages input', form).val('');
				}
			});

			// Financing HACK (works for now)
			// ----------------------------------
			$('input[name="financingCF"][value="Ja"]', form).val('Ja, wir brauchen Hilfe bei der Finanzierung');
			
			// Financing conditional
			$('input[name="financingCF"]', form).on('change', function(){
				if($(this).val().indexOf('Ja') === -1){
					$('.costs-wrapper, #costs', form).addClass('inactive');
					$('.costs-wrapper input', form).val('--'); // trick so the field will validate
				} else {
					$('.costs-wrapper, #costs', form).removeClass('inactive');
					$('.costs-wrapper input', form).val('');
				}
			});


			// Disclaimer Click Enhancement
			// ---------------------------------
			$('.disclaimer-label', form).on('click', function(){
				$(this).closest('.disclaimer').find('.wpcf7-checkbox input').click();
			});


			// Validate Pages
			// ---------------------------------
			function validateCurrentPage(){
				// debug
				var debug = false;
				if(debug){
					return true;
				}

				var valid = true;
				// var currentPage = $('.fw-form.in .fw-carousel .item.active');
				var currentPage = form.find('.fw-carousel .item.active');

				// reset all error alerts
				$('.wpcf7-not-valid', form).removeClass('wpcf7-not-valid');
				$('.wpcf7-not-valid-tip, .wpcf7-response-output-pagewise', form).remove();

				// Input / Select / Textarea
				var reqInputSelect = currentPage.find('input.wpcf7-validates-as-required, select.wpcf7-validates-as-required, textarea.wpcf7-validates-as-required').not('.datepicker');
				$.each(reqInputSelect, function(i, field){			
					if($(field).val() === ''){
						setInvalidField($(field));
						valid = false;
					}
				});

				// Chosen
				var cityCFChosen = currentPage.find('.fw-chosen-city_chosen > a > span');
				if(cityCFChosen.text().indexOf('--') >= 0){
					setInvalidField($('.fw-chosen-city_chosen .chosen-single'));
					valid = false;
				}

				// Checkboxes
				var reqCheckbox = currentPage.find('.wpcf7-checkbox.wpcf7-validates-as-required');
				$.each(reqCheckbox, function(i, checkboxGroup){
					if($(checkboxGroup).find('input[type="checkbox"]').filter(':checked').length === 0){
						setInvalidField($(checkboxGroup));
						valid = false;
					}
				});
        
        var reqRadios = currentPage.find('.wpcf7-radio');
        $.each(reqRadios, function(i, checkboxGroup){
          if($(checkboxGroup).find('input[type="radio"]').filter(':checked').length === 0){
            // custom code: ignore hidden radio-elements
            if ($(checkboxGroup).closest('p').is(':visible')) {
                setInvalidField($(checkboxGroup));
                valid = false;
            }
          }
        });

				// Datepicker
				var startDate = currentPage.find('#date-start');
				var endDate = currentPage.find('#date-end');
				if(startDate.length && startDate.val() === ''){
					setInvalidField($(startDate));
					valid = false;
				}
				if(endDate.length && endDate.val() === '' && !currentPage.find('.open-end input[type="checkbox"]').is(':checked')){
					setInvalidField($(endDate));
					valid = false;
				}

				// E-Mail
				var fieldEmail = currentPage.find('input[type="email"]');
				$.each(fieldEmail, function(i, mail){
					if($(mail).hasClass('.wpcf7-validates-as-required') && !$(mail).val().match(/.+@.+\..+/)){
						setInvalidField($(mail));
						valid = false;	
					} else {
						if($(mail).val().length > 0 && !$(mail).val().match(/.+@.+\..+/) && $('.contactPerson').is(':visible') ) {
							setInvalidEmail($(mail));
							valid = false;
						}
					}
				});		

				// Checkmail
				if(currentPage.find('#mail1').val() !== currentPage.find('#mail2').val()){
					setInvalidField(currentPage.find('#mail2'));
					valid = false;
				}

				// Phone
				var reqPhone = currentPage.find('input[type="tel"].wpcf7-validates-as-required');
				if(reqPhone.length && reqPhone.val().replace(/\D/g, '') === ''){
					reqPhone.addClass('wpcf7-not-valid');
					setInvalidField(reqPhone);
					valid = false;	
				}

				if(!valid){
					var response = '<div class="wpcf7-response-output wpcf7-response-output-pagewise wpcf7-validation-errors" role="alert">' + currentLang.errorValidation + '</div>';
					currentPage.append(response);
				}

				return valid;
			}

			function setInvalidField(field){
				var tip = '<span role="alert" class="wpcf7-not-valid-tip not-valid-required">' + currentLang.errorRequired + '</span>';
				field.addClass('wpcf7-not-valid');	
				field.after(tip);
			}

			function setInvalidEmail(field){
				var tip = '<span role="alert" class="wpcf7-not-valid-tip not-valid">' + currentLang.errorMailInvalid + '</span>';
				field.addClass('wpcf7-not-valid');	
				field.after(tip);
			}	

			// end validation ---------------------------------

			// Date Diff calculate Dauer
			// --------------------------------
			function calcLength() {
				var dateStartVal = $("#date-start", form).val();
				var dateEndVal = $("#date-end", form).val();

				if(dateStartVal === '' || dateEndVal === ''){
					return false;
				}

				var dateStartArray = $("#date-start", form).val().split('.');
				var dateEndArray = $("#date-end", form).val().split('.');

				var dateStart = new Date(dateStartArray[2], dateStartArray[1]-1, dateStartArray[0]);
				var dateEnd = new Date(dateEndArray[2], dateEndArray[1]-1, dateEndArray[0]);

			    var diff = Math.floor(dateStart.getTime() - dateEnd.getTime());
			    var day = 1000 * 60 * 60 * 24;

			    var days = Math.floor(diff/day);
			    var months = Math.floor(days/31);
			    var years = Math.floor(months/12);

			    var length = months*-1;
				$('input[name="dauer"]', form).val(length + ' Monate');
		    }

		    // Language Switch
		    // ---------------------------------------------------
		    var languageTexts;
		    var currentLang;

			$.ajax({
		        url: languageFile,
		        dataType: 'json',
		        success: function(data) {
    					languageTexts = data.languages;
    					defaultLanguage = getDefaultLanguageCode(data.defaultLanguage);
    					setLanguageTexts(defaultLanguage);
		        },
		        error: function(data){
		        	console.log('Error: file not found at url' + languageFile);
		        }
		    });

		    function getDefaultLanguageCode(defaultLanguage){
		    	var code = '';
		    	
		    	if(typeof fugee.iclLanguageCode !== 'undefined' && fugee.iclLanguageCode !== null && fugee.iclLanguageCode !== "") {
		    		code = fugee.iclLanguageCode;
		    	} else {
		    		code = defaultLanguage;
		    	}
		    	return code;
		    }

			function getLanguageTextObj(lang){
				var textObj = {};
				$.each(languageTexts, function(index, value){
					if(value.code === lang){
						textObj = value;
					}
				});
				return textObj;
			}

		    function setLanguageTexts(lang){
		    	currentLang = getLanguageTextObj(lang);

		    	if(languageTexts.length === 1){
		    		form.addClass('single-lang');
		    	} else {
		    		form.find('#form-lang-switch a[href="#' + defaultLanguage + '"]').closest('li').addClass('active');
		    	}
		    	 	
		    	$.each(currentLang, function(key, value){
		    		var el = $('.fw-text-' + key, form);
		    		var tagname = '';

		    		if(el.length){
		    			tagname = el[0].tagName.toLowerCase();
		    		}

		    		switch(tagname){
		    			case 'span':
		    				if(el.hasClass('wpcf7-checkbox') || el.hasClass('wpcf7-radio') ){
		    					var checkboxes = el.find('.wpcf7-list-item');
		    					$.each(checkboxes, function(index, val){
		    						$(val).find('.wpcf7-list-item-label').text(value[index]);
		    					});
		    				} else {
		    					el.html(value);    					
		    				}
		    				break;
		    			case 'select':
                var options = el.find('option');
                $.each( options, function( i, val ) {
                  $(val).text(value[i]);
                });			
		    				break;
		    			case 'textarea':
		    				el.attr('placeholder', value);
		    				break;
		    			// eg. Button, Input[type="text"] / morelanguages PLACEHOLDER
						case 'input':
							var classList = el.attr('class').toString();
							if(classList.indexOf('fw-text-placeholder') >= 0){
								el.attr('placeholder', value);
							} else {
								el.val(value);						
							}
							break;    				
		    		}

		    	});
          
          
        /**
         * Eigene Funktion für Länderliste!!!
         * 
         * 
         */
        setCountryList(lang);
        $('select', form ).trigger("chosen:updated");
        /**
         * Eigene Funktion für Länderliste!!!
         * 
         * 
         */

				// Error Messages
				$('.wpcf7-response-output-pagewise.wpcf7-validation-errors, .wpcf7-response-output.wpcf7-validation-errors', form).html(currentLang.errorValidation);
				onMailSentOk();
				$('.wpcf7-not-valid-tip.not-valid-required', form).html(currentLang.errorRequired);
				$('.wpcf7-not-valid-tip.not-valid', form).html(currentLang.errorMailInvalid);

				// Localize Datepicker
				$.datepicker.setDefaults( $.datepicker.regional[ lang ] );
		    }

		    $('#form-lang-switch a', form).on('click', function(e){
		    	var lang = $(this).attr('href').replace('#', '');
				
				setLanguageTexts(lang);
				$('#form-lang-switch li', form).removeClass('active');
				$(this).parent().addClass('active');

		    	e.preventDefault();
		    });

		    function onMailSentOk(){
		    	$('.wpcf7-response-output.wpcf7-mail-sent-ok', form).html(currentLang.mailSentOK);
		    }
			
  			$(document).on('mailsent.wpcf7', function () {
  			    onMailSentOk();
  			});
        
        
        // custom scripts starting here!!
        var allCountries = {
          'en': [], 
          'de': [],
          'val': []
        };
        
        $.ajax({
          url: jsDir + 'countries.json',
          dataType: 'json',
          success: function(countries) {
            getCountryList( countries );
            setCountryList( getDefaultLanguageCode('de') );
          },
          error: function(data){
          	console.log('Error: file not found at url' + languageFile);
          }
  		  });
        
        function setCountryList( lang ) {

          $("#nationalityCF option").each(function( i ) {
            var option = $(this);
            if (option.text() !== '---') {
              option.text(allCountries[lang][i-1]);
            }  
          });
          $('select[name="nationalityCF"]', form).trigger('chosen:updated');

        }
        
        function getCountryList( countries ) {
          countries.forEach( function(country) {
            $.each( country, function( key, value ) {

              if (typeof value === "object") {
                $.each(value, function(name, title) {
                  if ( name === "common") {
                    allCountries.en.push(title);
                  }
                  if ( name === "deu") {
                    $.each(title, function(type, transTitle) {
                      if (type === "common") {
                        allCountries.de.push(transTitle);
                        allCountries.val.push(transTitle);
                      }
                    });
                  }           
                });
              }
              
            });
          });
          
          $.each( allCountries.val, function(i) {
            $('select[name="nationalityCF"]', form).append('<option value="' + allCountries.val[i] + '"></option>' );
          });
          
        }
        
        $('select[name="nationalityCF"]', form).chosen({
          no_results_text: "Dein Land ist leider nicht dabei!",
          placeholder_text_single: '---',
          width: "100%"
        });
        
        $('select[name="stateCF"]', form).chosen({
          no_results_text: "Kein Bundesland gefunden",
          placeholder_text_single: '---',
          width: "100%"
        });
        
        $("#arrivalCF", form ).datepicker( "option", "maxDate", "-1" );
        $("#dateCF", form ).datepicker( "option", "minDate", "+1" );
        
        $('select[name^="age"], select[name="roommateGenderCF"], select[name="genderCF"], select[name="statusCF"], select[name="financeCF"], select[name="typeCF"], select[name="publicTransferCF"], select[name="periodCF"]', form).chosen({
            disable_search: true,
            placeholder_text_single: '---',
            width: "100%",
            inherit_select_classes: true
        });
        
        // radio-buttons - duplicate of validation-function for checkboxes - in validation-function
        // radio-buttons - ignore hidden inputs for validation

    	});// end each
        
    };// end plugin
 
}( jQuery ));